import React from 'react';
import useEffectOnce from '../useEffectOnce';

const useUnmount = (fn) => {
    const fnRef = React.useRef(fn);

    fnRef.current = fn;

    useEffectOnce(() => () => fnRef.current());
};

export default useUnmount;
